// export const BLOCKS_PER_DAY = 5730;
export const BLOCKS_PER_DAY = 5760;
export const baseUrl = "https://staging-api.acxd.io";
export const ANNUAL_REBASE =  2191.5;
